import { extendModule } from "ng";
import webmodals from "webmodals/_webmodals.app";
//import uiBootstrap from 'angular-ui-bootstrap';
import toggle from "webforms/toggle.directive";
import fileReader from "webforms/file-reader";
import checklistModel from "webforms/checklist-model";
import numericInputGroup from "webforms/numeric-input-group";
import formGroup from "webforms/form-group";
import validationSummary from "webforms/validation-summary";
import validNumber from "webforms/valid-number";
import formio, {
  dependencies as formioDependencies,
} from "webforms/formio/formio.module";

import "webforms/toggle.scss";
// import "ng-formio/lib";
// import "ng-formio/dist/formio.css";
// import "webforms/formio/formio-fixes.scss";
import uiSelect from "ui-select";
import "ui-select/dist/select.css";

const deps = [
  "ui.bootstrap",
  "ui.mask",
  uiSelect,
  "ngSanitize",
  webmodals,
  ...formioDependencies,
  // "formio",
];


export const app = angular
  .module("webforms", deps)
  .directive("checklistModel", checklistModel)
  .directive("toggle", toggle)
  .directive("fileReader", fileReader)
  .directive("formGroup", formGroup)
  .directive("validationSummary", validationSummary)
  .directive("validNumber", validNumber)
  .component("numericInputGroup", numericInputGroup);

extendModule(app, formio);

export default app.name;
